import * as React from 'react';
import { Component } from 'react';
import propz from 'propz';
import { uploadImage } from 'Src/helpers/service/image';
import { AppUser } from 'Src/views/App/App';
import './TournamentNationalGoverningBodiesForm.scss';

interface Props {
  nationalGoverningBody: any;
  user: AppUser;
  onCloseClick: (index) => void;
  onGlobalNationalGoverningBodiesFormChange: (event, index, field) => void;
  nationalGoverningBodyIndex: number;
}

interface State {
  isImageError: boolean;
}

export class TournamentNationalGoverningBodiesForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isImageError: false
    };
  }

  onImageSelected = event => {
    const { user, onGlobalNationalGoverningBodiesFormChange, nationalGoverningBodyIndex } = this.props;
    const image = event.target.files[0];
    uploadImage(user, image)
      .then(response => {
        const picUrl = `${window.apiImg}/images/${response.key}`;
        onGlobalNationalGoverningBodiesFormChange(picUrl, nationalGoverningBodyIndex, 'uploadImage');
        this.setState({
          isImageError: false
        });
      })
      .catch(error => {
        console.error(error);
        this.setState({ isImageError: true });
      });
  };

  render() {
    const { isImageError } = this.state;
    const { nationalGoverningBody, nationalGoverningBodyIndex } = this.props;
    const picUrl = propz.get(nationalGoverningBody, ['picUrl'], '');
    const isPicUrlExists = typeof picUrl !== 'undefined' && picUrl !== '';
    const link = propz.get(nationalGoverningBody, ['link'], ''),
      name = propz.get(nationalGoverningBody, ['name'], '');

    return (
      <div className="tgbForm">
        <div className="tgbForm__intro">
          <strong>Organisation details</strong>
          <span>Add a recognisable name, website and logo for the public tournament page.</span>
        </div>
        <div className="tgbForm__fields">
          <label><span>Name</span><input
            type="text"
            value={name}
            placeholder="Organisation name"
            onChange={event => {
              this.props.onGlobalNationalGoverningBodiesFormChange(event, nationalGoverningBodyIndex, 'name');
            }}
          /></label>
          <label><span>Website</span><input
            type="text"
            value={link}
            placeholder="https://example.org"
            onChange={event => {
              this.props.onGlobalNationalGoverningBodiesFormChange(event, nationalGoverningBodyIndex, 'link');
            }}
          /></label>
        </div>
        <div className="tgbForm__media">
          <span>Logo</span>
          <label className={`tgbForm__upload${isPicUrlExists ? ' has-image' : ''}`}>
            {isPicUrlExists ? <img src={picUrl} alt={name || 'Organisation logo'} /> : <><b>Choose a logo</b><small>PNG, JPG or another image file</small></>}
            <input type="file" name="picUrl" accept="image/*" onChange={this.onImageSelected} />
          </label>
          {isPicUrlExists && (
              <button
                type="button"
                className="tgbForm__remove"
                onClick={event => {
                  this.props.onGlobalNationalGoverningBodiesFormChange(
                    event,
                    nationalGoverningBodyIndex,
                    'removeImageButton'
                  );
                }}
              >
                Remove logo
              </button>
          )}
          {isImageError && <div className="tgbForm__error">The image could not be uploaded. Please try again.</div>}
        </div>
      </div>
    );
  }
}

